'use strict';exports.__esModule = true;var formatDescription = function formatDescription(routeData, translate, customParams) {
  // method placeholder

  return null;
};exports.default =

formatDescription;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/seo/residense/description.js
// module id = 3142
// module chunks = 0